module.exports = __webpack_public_path__ + "img/bb.ffa8b747.png";